import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./../components/Loader/Loader.sass"
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from 'react-device-detect'
import { apiUser, API_USER_BASE_URL } from "../basedata/apiCall";
import InfoModal from "./../components/Modal/ModalInfo"

const Validating = () => {

  const { t } = useTranslation(); 
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();

  const handleAcceptTerms = () => {
    setAccepted(!accepted);
  };

  const handleContinue = () => {
    if (accepted) {
      navigate("/signup");
    }
  }


    const fetchDocumentStatus = async (biometryToken:any) => {

      if(!biometryToken || biometryToken === 'null'){
        window.location.href = '/'
      }

      const eventSource = new EventSource(`${API_USER_BASE_URL}/biometry/flow-events?token=${biometryToken}`);
      
      eventSource.onmessage = (event) => {
        const _response_data = JSON.parse(event.data)

        console.log(_response_data.status)

        if(_response_data?.status === 'error'){
          return window.location.href = '/waiting'
        }

        if(_response_data && _response_data.status === 'success'){
          return window.location.href = '/success'
        }
      };
      
      eventSource.onerror = () => {
        console.log('Erro na conexão SSE. Tentando reconectar...');
        eventSource.close();
        setTimeout(() => {
          fetchDocumentStatus(biometryToken)
        }, 5000);
      };
    }
    
  const getUserFlow = async (userToken:any) => {

      if(!userToken || userToken === 'null'){
        window.location.href = '/'
      }

    try{
      const _response = await apiUser.post(`/biometry/flow/user-jorney`, {flowId: userToken})
      const _current_location = window.location.pathname

      console.log('resolve', _response.data?.message)

      if(_response.data.status === 'success'){
        sessionStorage.setItem('user_history', _response.data.message)
        sessionStorage.setItem('get_flow_index', 'true')
        
        
        if(_response.data.message === 'selfie'){
          if(!/selfie/.test(_current_location)){
            window.location.href = 'selfie'
          }
        }else if(_response.data.message === 'document_front'){
          if(!/mobile-document/.test(_current_location)){
            window.location.href = 'mobile-document'
          }
        }else if(_response.data.message === 'document_back'){
          if(!/mobile-document/.test(_current_location)){
            window.location.href = 'mobile-document?step=document_back'
          }
        }else if(_response.data.message === 'done'){
          if(!/success/.test(_current_location)){
            window.location.href = 'success'
          }
        }else if(_response.data.message === 'processing'){
          if(!/success/.test(_current_location) && !/waiting/.test(_current_location)){
           return fetchDocumentStatus(userToken)
          }
        }else{
          window.location.href = '/'
        }
      }else if(_response.data?.message === 'facematch_completed'){
        if(!/mobile-document/.test(_current_location)){
          window.location.href = 'mobile-document'
        }
      }

    if(_response.data.validation === 'failed'){
      if(_response.data?.message === 'facematch_failed'){
        sessionStorage.setItem('facemath_check', 'failed')
        return setIsModalOpen(true)
      }
      window.location.href = 'selfie'
    }

    }catch(e){
      setTimeout(() => {
        console.log('se timezito~ xxxx')
        // window.location.reload()
        window.location.href = 'selfie'
      }, 3000);
    }
    console.log('se fue~ xxxx')
    return true
  }
  

  useEffect(() => {

    const params = new URLSearchParams(window.location.search)
    let currentToken = params.get('token'),
    currentCompany = params.get('orc')

    if(currentToken){
      sessionStorage.setItem('token', `${currentToken}`)
      sessionStorage.setItem('originCompany', `${currentCompany}`)
    }else{
    currentToken = sessionStorage.getItem('token')
    currentCompany = sessionStorage.getItem('orc')
    }

    if(!currentToken){
      console.log('utautauta')
      window.location.href = '/'
    }

    getUserFlow(currentToken);

    // if(isMobile){
    //   window.location.href = `/selfie?token=${currentToken}`
    // }else{
    //   window.location.href = `/mobile-handler?token=${currentToken}`
    // }
  }, []);



    const [isModalOpen, setIsModalOpen] = useState(false);
    const [error_message, setError_message] = useState('A sua selfie e a foto do documento não batem.');
    const closeModal = () => {
      setIsModalOpen(false);
      window.location.href = 'selfie'
    };

  return (
    <>
        <InfoModal isOpen={isModalOpen} onClose={closeModal}>
            <h1>Opa!</h1>
            <p>{error_message}</p>
            <button className='button-retry-action' onClick={() => window.location.href = 'selfie'}>{t('success_document.try_again')}</button>
        </InfoModal>
        
    <div className="loader">
        <div className="spinner">
        </div>
    </div>
    </>
  );
};

export default Validating;
